import React, { Component, Suspense } from 'react';
import { lazyPage } from '../../utils/lazyPage';

// Far down the Catering page, with its own menu search: in its own chunk, so it doesn't
// weigh on every page of the site. It starts loading as soon as the Catering page shows.
const QuoteForm = lazyPage(() => import(/* webpackChunkName: "quote-form" */ './QuoteForm'));

/** If the form can't load (a real outage — lazyPage already waits out offline), a call-us line stands in. */
class QuoteBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error('[catering] the quote form failed to load:', error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <section className="ct-quote-slot" id="catering-quote">
        <p className="ct-quote-slot__text">
          The quote form couldn’t load. Please call us at <a href="tel:+14794129916">(479) 412-9916</a>, or reload the page.
        </p>
      </section>
    );
  }
}

/** The "Request a Quote" form (QuoteForm.js), loaded on its own; a box of about its size holds its place. */
export default function LazyQuoteForm(props) {
  return (
    <QuoteBoundary>
      <Suspense fallback={<section className="ct-quote-slot ct-quote-slot--loading" id="catering-quote" aria-busy="true" />}>
        <QuoteForm {...props} />
      </Suspense>
    </QuoteBoundary>
  );
}
